import './devices.scss';
import React, {useEffect} from 'react';
import {DEVICES_POLLING} from '@src/utils/constants';
import {observer} from 'mobx-react-lite';
import {useStores} from '@src/components/store';
import {InteractiveDataTable} from '@src/components/shared/interactive-data-table/interactive-data-table';
import {DeviceRow} from '@src/dtos/device.dto';
import {devicesColumns} from './devices-columns-config';
import {useDevicesCrudConfig} from './devices-crud-config';
import {EmptyState} from '@src/components/shared/empty-state/empty-state';
import {IconType} from '@src/components/shared/custom-icon/custom-icon';
import {useDevicesFiltersConfig} from './devices-filters';

export const Devices = observer(() => {
    const {devicesStore, customerStore} = useStores();
    const filterConfig = useDevicesFiltersConfig();
    const hasSelectedCustomerAndService = customerStore.customerId > 0 && customerStore.serviceId > 0;

    useEffect(() => {
        if (!hasSelectedCustomerAndService) {
            return;
        }

        void devicesStore.load();
        const intervalId = window.setInterval(() => {
            devicesStore.loadSilently().catch(() => undefined);
        }, DEVICES_POLLING);

        return () => {
            window.clearInterval(intervalId);
        };
    }, [devicesStore, hasSelectedCustomerAndService]);

    return <div className="devices" data-testid="devices">
        <InteractiveDataTable<DeviceRow>
            subTitle={`Devices (${devicesStore.totalCount})`}
            filterConfig={filterConfig}
            data={devicesStore.devices}
            columnsConfig={devicesColumns}
            crudConfig={useDevicesCrudConfig()}
            emptyStateComp={<EmptyState iconType={IconType.SMARTPHONE}
                                        title="No devices yet"
                                        subTitle="To add new item click"
                                        secondarySubTitle="Add device"/>}
            dataHasLoaded={!devicesStore.isLoading}
            isLoading={devicesStore.isLoading}/>
    </div>;
});
